/**
 * Mega Menu — hover para abrir + alinhamento de colunas
 */
(function () {

  function initHover() {
    document.querySelectorAll('.header__inline-menu .mega-menu').forEach(function (details) {
      var content = details.querySelector('.mega-menu__content');
      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      }

      details.addEventListener('mouseenter', openMenu);

      // Pequeno delay ao sair do trigger para cobrir o gap até o painel
      details.addEventListener('mouseleave', function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 80);
      });

      if (content) {
        // Chegou no painel — cancela o timer e mantém aberto
        content.addEventListener('mouseenter', openMenu);
        // Saiu do painel — fecha imediatamente
        content.addEventListener('mouseleave', function () {
          clearTimeout(closeTimer);
          details.removeAttribute('open');
        });
      }
    });
  }

  function alignMegaMenuColumns() {
    var inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    var inners = document.querySelectorAll('.mega-menu__inner');
    if (!inners.length) return;

    inners.forEach(function (el) { el.style.paddingLeft = ''; });

    var navLeft   = inlineMenu.getBoundingClientRect().left;
    var innerLeft = inners[0].getBoundingClientRect().left;

    var itemPaddingPx = parseFloat(getComputedStyle(
      inlineMenu.querySelector('.header__menu-item') || inlineMenu
    ).paddingLeft) || 0;

    var offset = (navLeft + itemPaddingPx) - innerLeft;

    if (offset > 0) {
      inners.forEach(function (el) {
        el.style.paddingLeft = offset + 'px';
      });
    }
  }

  function init() {
    initHover();
    requestAnimationFrame(function () {
      requestAnimationFrame(alignMegaMenuColumns);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(alignMegaMenuColumns, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', alignMegaMenuColumns);

})();
